import { useEffect, useState } from 'react';
import { uniqBy } from 'lodash';

export type PropertyTypeOption = {
  id: number;
  label: string;
};

const PROPERTY_TYPE_SELECT_SELECTOR = '.js-property-type-id';
const PROPERTY_TYPE_SELECT_CONTAINER = '.js-property-type-selector';

const readPropertyTypeOptions = (): PropertyTypeOption[] => {
  const selects = document.querySelectorAll<HTMLSelectElement>(PROPERTY_TYPE_SELECT_SELECTOR);
  const options: PropertyTypeOption[] = [];
  selects.forEach((select) => {
    if (select.offsetParent === null) return;
    const id = Number(select.value);
    const selectedOption = select.options[select.selectedIndex];
    const label = selectedOption ? selectedOption.text.trim() : String(id);
    options.push({ id, label });
  });
  return uniqBy(options, 'id');
};

export const usePropertyTypeOptions = (): PropertyTypeOption[] => {
  const [propertyTypeOptions, setPropertyTypeOptions] = useState<PropertyTypeOption[]>(
    () => readPropertyTypeOptions(),
  );

  useEffect(() => {
    const onChange = (event: Event) => {
      const target = event.target as HTMLElement | null;
      if (!target || typeof target.closest !== 'function') return;
      if (!target.closest(PROPERTY_TYPE_SELECT_CONTAINER)) return;
      setPropertyTypeOptions(readPropertyTypeOptions());
    };
    document.addEventListener('change', onChange);
    return () => document.removeEventListener('change', onChange);
  }, []);

  return propertyTypeOptions;
};
